<template>
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.579 2.17666C20.1707 2.76827 20.1707 3.72746 19.579 4.31906L3.86887 20.0292C3.27726 20.6208 2.31807 20.6208 1.72646 20.0292C1.13485 19.4376 1.13485 18.4784 1.72646 17.8868L9.58155 10.0317L17.4366 2.17666C18.0282 1.58505 18.9874 1.58505 19.579 2.17666Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.04198 3.38813C3.87995 3.38813 2.93794 4.33014 2.93794 5.49217C2.93794 6.6542 3.87995 7.59621 5.04198 7.59621C6.20401 7.59621 7.14602 6.6542 7.14602 5.49217C7.14602 4.33014 6.20401 3.38813 5.04198 3.38813ZM0.413086 5.49217C0.413086 2.93571 2.48551 0.863281 5.04198 0.863281C7.59844 0.863281 9.67087 2.93571 9.67087 5.49217C9.67087 8.04864 7.59844 10.1211 5.04198 10.1211C2.48551 10.1211 0.413086 8.04864 0.413086 5.49217Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.2635 14.6097C15.1015 14.6097 14.1595 15.5517 14.1595 16.7137C14.1595 17.8758 15.1015 18.8178 16.2635 18.8178C17.4256 18.8178 18.3676 17.8758 18.3676 16.7137C18.3676 15.5517 17.4256 14.6097 16.2635 14.6097ZM11.6346 16.7137C11.6346 14.1573 13.7071 12.0848 16.2635 12.0848C18.82 12.0848 20.8924 14.1573 20.8924 16.7137C20.8924 19.2702 18.82 21.3426 16.2635 21.3426C13.7071 21.3426 11.6346 19.2702 11.6346 16.7137Z"
      fill="white"
    />
  </svg>
</template>
